import SvgIcon from "../../utils/Icon";
import { ReactComponent as Calendario } from '../../assets/icons/calendario.svg';
import { ReactComponent as Buscar } from '../../assets/icons/lupa.svg';
import DoctorCard from "../PatientComponent/DoctorCard";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import { alertaGeneral } from "../../utils/alertas";
import DoctorCalendar from "../PatientComponent/DoctorCalendar";
import apiClient from "../../utils/axiosPetition";
import CustomModal from "../GlobalComponents/CustomModal";
import doctorService from "../../api/doctorService";
import { useDataUser } from "../../context/dataUserContext";
import Cargando from "../../utils/Cargando";
import useIsMobile from "../../utils/isMobile";
import { useMembership } from "../../context/MembershipContext";
import { FeatureGuard } from "../Membership/FeatureGuard";
import BotonUpgradeEpayco from "../ePayco/BotonUpgradeEpayco";
import { FaCrown, FaLock, FaStar } from 'react-icons/fa';

const AgendarTeleconsulta = () => {
    const { isAuth, patientId, role, doctorId, clinicId } = useDataUser();
    const { isPremium, isFree } = useMembership();
    const location = useLocation();
    const [showCalendar, setShowCalendar] = useState(false);
    const [cargando, setCargando] = useState(true);
    const [doctors, setDoctors] = useState([]);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [doctorsFilters, setDoctorsFilters] = useState([]);
    const [filtro, setFiltro] = useState('');
    const [filtroServicio, setFiltroServicio] = useState('');
    const [totalDoctors, setTotalDoctors] = useState(0);
    const [premiumDoctors, setPremiumDoctors] = useState(0);
    const [isProfileComplete, setIsProfileComplete] = useState(true);
    const isMobile = useIsMobile();
    const [modalOpenProfile, setModalOpenProfile] = useState(false);
    
    // Obtener el doctor del estado de navegación
    const doctorFromState = location.state?.doctor;

    const loadPremiumDoctors = async () => {
        try {
            setCargando(true);
            
            const result = await doctorService.getPremiumDoctors(isAuth, clinicId);
            
            if (result.success) {
                setDoctors(result.doctors);
                setTotalDoctors(result.total);
                setPremiumDoctors(result.premium);
                console.log('Doctores PREMIUM cargados para teleconsultas:', result);
            } else {
                setDoctors([]);
                setTotalDoctors(0);
                setPremiumDoctors(0);
            }
        } catch (error) {
            console.error('Error cargando doctores PREMIUM para teleconsultas:', error);
            alertaGeneral({
                titulo: 'Error',
                messageHtml: 'Ocurrió un error al cargar los profesionales PREMIUM, intente nuevamente',
                isError: true
            });
            setDoctors([]);
        } finally {
            setCargando(false);
        }
    };

    // Verificar si el perfil del paciente está completo
    const checkProfileCompletion = async () => {
        // Si el usuario es doctor, no validar perfil de paciente
        if (role === 'doctor') {
            console.log('Usuario es doctor, no se valida perfil de paciente');
            setIsProfileComplete(true);
            return;
        }

        if (!isAuth || !patientId) {
            console.log('No hay auth o patientId, permitiendo acceso');
            setIsProfileComplete(true);
            return;
        }

        try {
            const response = await apiClient.get(`/api/patient/isCompleteProfile/${patientId}`);
            console.log('Respuesta de verificación de perfil:', response.data);
            setIsProfileComplete(response.data.isComplete);
        } catch (error) {
            console.error('Error verificando estado del perfil:', error);
            // Si hay error, permitir agendar
            setIsProfileComplete(true);
        }
    };

    useEffect(() => {
        loadPremiumDoctors();
        checkProfileCompletion();
    }, [isAuth, patientId, role]);

    // Removida validación de perfil completo - ya no se requiere para agendar citas
    // useEffect(() => {
    //     if (!isProfileComplete) {
    //         setModalOpenProfile(true);
    //     } else {
    //         setModalOpenProfile(false);
    //     }
    // }, [isProfileComplete]);

    useEffect(() => {
        let doctorToReturn = doctors.filter(doc =>
            filtro ? doc.fullName?.toLowerCase().includes(filtro.toLowerCase())
                : filtroServicio ? doc.service?.toLowerCase().includes(filtroServicio.toLowerCase())
                    : doc
        );
        
        // Separar doctores Premium y Free
        const premiumDoctors = doctorToReturn.filter(doc => doc.membershipPlan === 'premium');
        const freeDoctors = doctorToReturn.filter(doc => doc.membershipPlan !== 'premium');
        
        // Ordenar: Premium primero, luego Free
        let doctorsOrdenados = [...premiumDoctors, ...freeDoctors];
        
        // Si el usuario es free, mostrar solo 3 doctores PREMIUM (y todos los free)
        if (isFree()) {
            const premiumLimitados = premiumDoctors.slice(0, 3);
            doctorsOrdenados = [...premiumLimitados, ...freeDoctors];
        }
        
        setDoctorsFilters(doctorsOrdenados);
        
        // Si hay un doctor del estado de navegación, seleccionarlo automáticamente
        if (doctorFromState && doctors.length > 0) {
            const doctorEncontrado = doctors.find(doc => doc._id === doctorFromState._id);
            if (doctorEncontrado) {
                setSelectedDoctor(doctorEncontrado);
                setShowCalendar(true);
                // Aplicar filtros para mostrar solo este doctor
                setFiltro(doctorEncontrado.fullName);
                setFiltroServicio(doctorEncontrado.service);
            }
        }
    }, [doctors, filtro, filtroServicio, isFree, doctorFromState]);


    // Componente para mostrar el prompt de actualización
    const UpgradePrompt = () => (
        <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border border-yellow-200 rounded-lg p-8 text-center">
            <div className="flex justify-center mb-4">
                <div className="bg-yellow-100 p-4 rounded-full">
                    <FaLock className="text-yellow-600 text-3xl" />
                </div>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Acceso a Teleconsultas con Profesionales PREMIUM
            </h3>
            <p className="text-gray-600 mb-6 max-w-md mx-auto">
                Para acceder a todos los profesionales PREMIUM disponibles y agendar teleconsultas sin restricciones, 
                necesitas actualizar a nuestro plan Premium.
            </p>
            
            <div className="bg-white rounded-lg p-6 mb-6 max-w-md mx-auto">
                <h4 className="font-semibold text-gray-900 mb-3 flex items-center justify-center">
                    <FaStar className="text-yellow-500 mr-2" />
                    Beneficios Premium de Teleconsultas
                </h4>
                <ul className="text-sm text-gray-600 space-y-2 text-left">
                    <li className="flex items-center">
                        <FaCrown className="text-yellow-500 mr-2 flex-shrink-0" />
                        Acceso a todos los profesionales PREMIUM disponibles
                    </li>
                    <li className="flex items-center">
                        <FaCrown className="text-yellow-500 mr-2 flex-shrink-0" />
                        Agendar citas sin restricciones
                    </li>
                    <li className="flex items-center">
                        <FaCrown className="text-yellow-500 mr-2 flex-shrink-0" />
                        Prioridad en la agenda de profesionales PREMIUM
                    </li>
                    <li className="flex items-center">
                        <FaCrown className="text-yellow-500 mr-2 flex-shrink-0" />
                        Soporte prioritario para citas
                    </li>
                </ul>
            </div>

            <BotonUpgradeEpayco
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-yellow-400 to-yellow-600 text-white font-semibold rounded-lg hover:from-yellow-500 hover:to-yellow-700 transition-all transform hover:scale-105 shadow-lg"
                onSuccess={(epaycoData) => {
                    console.log('Upgrade iniciado desde teleconsultas:', epaycoData);
                }}
                onError={(error) => {
                    console.error('Error en upgrade desde teleconsultas:', error);
                }}
            >
                <FaCrown className="mr-2" />
                Actualizar a Premium
            </BotonUpgradeEpayco>
        </div>
    );

    if (cargando) {
        return <Cargando />
    }

    // Removida validación de perfil completo - ya no se requiere para agendar citas
    // if (!isProfileComplete && role !== 'doctor') {
    //     console.log('Perfil incompleto, mostrando modal bloqueante');
    //     return (
    //         <CustomModal
    //             open={true}
    //             onClose={() => {}}
    //             title={"Perfil Incompleto"}
    //             confirmText={"Ir a Completar Perfil"}
    //             onConfirm={() => { window.location.href = '/patient/perfil'; }}
    //         >
    //             <div className="text-center">
    //                 <p className="mb-4 text-gray-700">
    //                     Para agendar citas debes completar tu perfil primero.
    //                 </p>
    //                 <p className="text-sm text-gray-600">
    //                     Haz clic en el botón de abajo para completar tu información personal.
    //                 </p>
    //             </div>
    //         </CustomModal>
    //     );
    // }

    return (
        <section className="rounded-[1.75rem] md:rounded-[2rem] overflow-hidden shadow-[0_8px_30px_-8px_rgba(31,148,194,0.15),0_4px_16px_-6px_rgba(0,0,0,0.08)]">
            <h2 className="flex items-center bg-gradient-to-r from-[#1f94c2ff] to-[#1a7fa8] text-sm md:text-base text-white font-medium px-5 md:px-8 py-3 rounded-t-[1.75rem] md:rounded-t-[2rem]">
                <SvgIcon Icon={Calendario} className="w-5 h-5 md:w-6 md:h-6 mr-2 md:mr-3 shrink-0" />
                <span className="truncate">Agendar cita</span>
            </h2>

            
            <div className="bg-white justify-center py-3 md:py-5 relative">
                {/* Filtros de búsqueda */}
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2 md:gap-3 mb-3 md:mb-4 px-4 md:px-6">
                    <div className="flex items-center rounded-xl border border-slate-200 bg-slate-50/50 shadow-sm overflow-hidden focus-within:border-slate-300 transition-colors max-w-md w-full sm:max-w-[220px]">
                        <span className="flex items-center justify-center bg-[#1f94c2ff] text-white w-11 shrink-0 self-stretch">
                            <SvgIcon Icon={Calendario} className="w-4 h-4 md:w-5 md:h-5" />
                        </span>
                        <select
                            id="service"
                            name="service"
                            className="flex-1 min-w-0 py-2.5 px-3 bg-transparent border-0 text-sm md:text-base text-slate-700 focus:outline-none focus:ring-0 cursor-pointer"
                            onChange={(ev) => setFiltroServicio(ev.target.value)}
                        >
                            <option value="">Todos</option>
                            <option value="medicina familiar">Médico familiar</option>
                            <option value="medicina general">Médico general</option>
                            <option value="fonoaudiología">Fonoaudiología</option>
                            <option value="terapeuta respiratorio">Terapeuta respiratoria</option>
                            <option value="terapia física">Terapia física</option>
                            <option value="fisioterapeuta">Fisioterapeuta</option>
                            <option value="terapeuta ocupacional">Terapeuta ocupacional</option>
                            <option value="enfermería">Enfermería</option>
                            <option value="nutrición">Nutrición</option>
                            <option value="psicología">Psicología</option>
                        </select>
                    </div>
                    <div className="flex items-center rounded-xl border border-slate-200 bg-slate-50/50 shadow-sm overflow-hidden focus-within:border-slate-300 transition-colors max-w-md w-full sm:flex-1 sm:max-w-md">
                        <span className="flex items-center justify-center bg-[#1f94c2ff] text-white w-11 shrink-0 self-stretch">
                            <SvgIcon Icon={Buscar} className="w-4 h-4 md:w-5 md:h-5" />
                        </span>
                        <input
                            type="text"
                            placeholder="Buscar por nombre"
                            className="flex-1 min-w-0 py-2.5 px-3 bg-transparent border-0 text-sm md:text-base text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-0"
                            onChange={(e) => setFiltro(e.target.value)}
                        />
                    </div>
                </div>

                <div className="flex flex-col md:flex-row justify-between gap-4">
                    <div className={`relative w-full px-2 md:px-6`}>
                        <div className="flex flex-col gap-y-4">
                        {(() => {
                            // Separar Premium y Free para mostrar encabezados
                            const premiumList = doctorsFilters.filter(doc => doc.membershipPlan === 'premium');
                            const freeList = doctorsFilters.filter(doc => doc.membershipPlan !== 'premium');
                            
                            return (
                                <>
                                    {/* Sección Premium */}
                                    {premiumList.length > 0 && (
                                        <>
                                            <div className="flex items-center mb-1">
                                                <FaCrown className="text-yellow-500 mr-2 text-base shrink-0" />
                                                <h3 className="text-base md:text-lg font-semibold text-[#205087ff]">
                                                    Profesionales Premium ({premiumList.length})
                                                </h3>
                                            </div>
                                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                            {premiumList.map((doc, index) => (
                                                <SimpleDoctorCard 
                                                    key={doc._id || index}
                                                    doctor={doc}
                                                    currentDoctorId={doctorId}
                                                    showCalendar={showCalendar}
                                                    setShowCalendar={setShowCalendar}
                                                    selectedDoctor={selectedDoctor}
                                                    setSelectedDoctor={setSelectedDoctor}
                                                    isMobile={isMobile}
                                                    isProfileComplete={isProfileComplete}
                                                    openProfileModal={() => setModalOpenProfile(true)}
                                                />
                                            ))}
                                            </div>
                                        </>
                                    )}
                                    
                                    {/* Separador visual */}
                                    {premiumList.length > 0 && freeList.length > 0 && (
                                        <div className="my-2 border-t-2 border-gray-200"></div>
                                    )}
                                    
                                    {/* Sección Free */}
                                    {freeList.length > 0 && (
                                        <>
                                            <div className="flex items-center mb-1">
                                                <h3 className="text-base md:text-lg font-semibold text-gray-600">
                                                    Otros Profesionales ({freeList.length})
                                                </h3>
                                            </div>
                                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                            {freeList.map((doc, index) => (
                                                <SimpleDoctorCard 
                                                    key={doc._id || `free-${index}`}
                                                    doctor={doc}
                                                    currentDoctorId={doctorId}
                                                    showCalendar={showCalendar}
                                                    setShowCalendar={setShowCalendar}
                                                    selectedDoctor={selectedDoctor}
                                                    setSelectedDoctor={setSelectedDoctor}
                                                    isMobile={isMobile}
                                                    isProfileComplete={isProfileComplete}
                                                    openProfileModal={() => setModalOpenProfile(true)}
                                                />
                                            ))}
                                            </div>
                                        </>
                                    )}
                                    
                                    {doctorsFilters.length === 0 && (
                                        <div className="text-center py-6 text-gray-500 text-sm">
                                            No se encontraron profesionales
                                        </div>
                                    )}
                                </>
                            );
                        })()}
                        </div>
                    </div>
                        {/* Modal para el calendario (escritorio y móvil) - centrado */}
                        {showCalendar && selectedDoctor && createPortal(
                            <div className="fixed inset-0 z-[80] p-3 sm:p-4 bg-black/50 backdrop-blur-sm flex items-center justify-center overflow-y-auto">
                                <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col my-auto border border-slate-100 animate-fadeIn">
                                    <div className="flex justify-end p-2 md:p-3 shrink-0">
                                        <button className="p-2 text-gray-400 hover:text-[#1f94c2ff] hover:bg-slate-100 rounded-lg text-2xl font-bold leading-none transition-colors" onClick={() => setShowCalendar(false)} aria-label="Cerrar">×</button>
                                    </div>
                                    <div className="flex-1 min-h-0 overflow-y-auto px-3 pb-4">
                                        <DoctorCalendar show={showCalendar} doctor={selectedDoctor} isProfileComplete={isProfileComplete} isInModal />
                                    </div>
                                </div>
                            </div>,
                            document.body
                        )}
                </div>
            </div>
        </section>
    )
}

export default AgendarTeleconsulta;

const SimpleDoctorCard = ({ doctor, showCalendar, setShowCalendar, selectedDoctor, setSelectedDoctor }) => {
    const esOtraTarjeta = showCalendar && selectedDoctor?._id !== doctor._id;

    return (
        <div className="relative h-full w-full min-w-0">
            {esOtraTarjeta && (
                <div className="absolute inset-0 bg-white/40 pointer-events-none z-10 rounded-2xl" />
            )}
            <DoctorCard
                doctor={doctor}
                onAgendar={() => {
                    setSelectedDoctor(doctor);
                    setShowCalendar(true);
                }}
            />
        </div>
    );
};
